class CustomDropdown extends HTMLElement {
  loading = false

  constructor() {
    super()
    this._handleToggle = this._handleToggle.bind(this)
    this.close = this.close.bind(this)
    this._handleDocumentClick = this._handleDocumentClick.bind(this)
  }

  connectedCallback() {
    this.$toggle = this.querySelector('[data-toggle]')
    this._attachListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  static get observedAttributes() {
    return ['open']
  }

  attributeChangedCallback(name) {
    if (name === 'open') {
      this._appleState()
    }
  }

  get isAccordionMode() {
    return this.hasAttribute('accordion')
  }

  get isOpen() {
    return this.hasAttribute('open')
  }

  _attachListeners() {
    this.$toggle.addEventListener('click', this._handleToggle)
    this.addEventListener('change', this._handleUpdateLabel)
    if (!this.isAccordionMode) {
      this.addEventListener('change', this.close)
      document.addEventListener('click', this._handleDocumentClick)
    }
  }

  _removeListeners() {
    this.removeEventListener('change', this.close)
    this.removeEventListener('change', this._handleUpdateLabel)
    this.$toggle.removeEventListener('click', this._handleToggle)
    document.removeEventListener('click', this._handleDocumentClick)
  }

  _handleUpdateLabel(e) {
    const dataLabelEl =
      this.querySelector('[data-toggle]')?.querySelector('[data-label]')
    const label = dataLabelEl?.dataset?.label || ''

    if (!dataLabelEl) return
    const optionLabel = e.target?.dataset?.inputLabel

    dataLabelEl.innerHTML = `${label}: ${optionLabel}`
    dataLabelEl.setAttribute('aria-live', 'polite')
  }

  close() {
    this.removeAttribute('open')
    this.$toggle.setAttribute('aria-expanded', 'false')
  }

  open() {
    this.setAttribute('open', 'true')
    this.$toggle.setAttribute('aria-expanded', 'true')
  }

  _handleToggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  _handleDocumentClick(event) {
    if (this.isOpen && !this.contains(event.target)) {
      this.close()
    }
  }

  _appleState() {
    this.classList.toggle('open', this.isOpen)
  }
}

document
  .querySelectorAll('.collection-filters__sort-dropdown-item')
  .forEach((item) => {
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault() // Prevent the default action to stop space from scrolling the page
        let input = this.querySelector('input[type="radio"]')
        if (!input.checked) {
          input.checked = true
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    })
  })
window.customElements.define('custom-dropdown', CustomDropdown)
